export { default as blank } from './blank.svg';
export { default as balls } from './loading-balls.svg';
export { default as bars } from './loading-bars.svg';
export { default as bubbles } from './loading-bubbles.svg';
export { default as cubes } from './loading-cubes.svg';
export { default as cylon } from './loading-cylon.svg';
export { default as spin } from './loading-spin.svg';
export { default as spinningBubbles } from './loading-spinning-bubbles.svg';
export { default as spokes } from './loading-spokes.svg';



// WEBPACK FOOTER //
// ./lib/svg/index.js